import React from 'react';
import PaginationBase from '../../../common/base/PaginationBase';
import { message } from 'antd';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { SOLES } from '../../../common/types/monedaType';

import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import proveedorService from '../../../service/administracion/proveedorService';
import { FACTURA, ORDEN_COMPRA, OTROS } from '../../../common/types/tipoComprobanteType';

import ordenCompraService from '../../../service/logistica/ordenCompraService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModalVer from '../OrdenCompra/FormModalVer';
import ImprimirModal from '../OrdenCompra/ImprimirModal';
import IngresoObservacionModal from './IngresoObservacionModal'

var referenciaCount = 1;


export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        debugger
        this.state = {
            loadingSource: true,
            formValues: this.fetchEmptyFormValues(),
            filter: {
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                documento: '',
                serie: '',
                idEstadoOrdenCompra:0,
                idProveedor:0,
                ...FILTER
            },
            estadosOrdenCompra: [],
            pagination: PAGINATION,
            visible: false,
            proveedores: [],

            visibleVer: false,
            ingresoObservacionModal: {
                nombre: ''
            },
            imprimirFormValues: {
                file: undefined,
                idOrdenCompra: 0
            }
        }
    }

    async componentDidMount() {
        this._initPagination(this.state.filter, ordenCompraService.paginacion);

        const filter = {
            numeroDocumento: null,
            idTipoComprobante: OTROS.ID// FACTURA.ID
        }

        const proveedores = await proveedorService.obtenerTodos(filter);

        const ordenCompraEstados = [
            { id: 0, nombre: '- TODOS -' },
            { id: 1, nombre: 'REGISTRADO' },
            { id: 2, nombre: 'ANULADO' },
            { id: 3, nombre: 'APROBADO' },
            { id: 5, nombre: 'IMPORTADO' },
            { id: 4, nombre: 'RECHAZADO' }
        ];

        this.setState({
            loadingSource: false,
            estadosOrdenCompra: ordenCompraEstados,
            proveedores: proveedores ? proveedores : [] 

            
        });
    }

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleKeyUpInputSelect = (e) => {
        debugger
        //e.preventDefault();
        //if (e.keyCode === 13) {
        const filter = { ...this.state.filter, ...FILTER, idEstadoOrdenCompra: e.key };
        this._handlePagination(filter);
        //}
    };

    handleClearFilters = () => {
        var filter = {
            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            documento: '',
            serie: '',
            idEstadoOrdenCompra:0,
            idProveedor:0,
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleChangeTab = (key) => {
        this.setState({
            formValues: {
                ...this.state.formValues,
                activeKey: key
            }
        });
    };

    handleVer = async (values) => {
        const response = await ordenCompraService.obtenerPorId(values.id);
        if (response !== undefined) {
            var formValues = this.fetchEditFormValues(response);

            for (var i = 0; i < response.ordenCompraDetalles.length; i++) {
                var item = response.ordenCompraDetalles[i];
                var oneProd = {
                    idProducto: item.idProducto,
                    nombre: item.nombre,
                    cantidad: item.cantidad,
                    codigo: item.codigoReferencia,
                    nombreUnidadMedida: item.nombreUnidadMedida,
                    precioUnitario: item.precioUnitario,
                    total: item.total,
                    flagAfecto: item.flagAfecto,
                    flagExonerado: item.flagExonerado,
                    flagGratuito: item.flagGratuito,
                    precioUnitarioSinIGV: 0,
                    subTotal: item.subTotal,
                    igv: item.igv
                }

                formValues.listaComprobanteDetalle.push(oneProd);

            }

            for (var i = 0; i < response.ordenCompraReferencias.length; i++) {
                referenciaCount = i + 1;
                var item = response.ordenCompraReferencias[i];
                var oneRef = {
                    identifier: referenciaCount,
                    idReferencia: item.id,
                    idReferenciaOrigen: item.idReferenciaOrigen,
                    idTipoComprobante: item.idTipoComprobante,
                    serie: item.serie,
                    documento: item.documento,
                    flagInterno: true,
                    nombreTipoComprobante: item.nombreTipoComprobante
                }
                formValues.listaComprobanteReferencia.push(oneRef);
            }

            this.setState({
                visibleVer: true,
                formValues,
                //productoModal: {
                //    ...this.state.productoModal,
                //    selectedRowKeys: []
                //}
            });
        }
    }

    handleRechazar = async (values) => {
        dialog.confirm(`¿Desea rechazar la Orden de Compra ${values.serie}-${values.documento}?`, async () => {
            debugger
            const emptyForm = this.fetchEmptyFormValues();
            emptyForm.iD = values.id;
            this.setState({
                visible: true,
                formValues: emptyForm,
                ingresoObservacionModal: {
                    ...this.state.ingresoObservacionModal
                }
            });
        });
    }

    handleCompletarRechazo = async (values, form) => {
        debugger
        var data = {
            idOrdenCompra: values.id,
            codOrdenCompraEstado: 'RE',
            observacionRechazado: values.observacionRechazo
        };
        console.log(data);
        var response = await ordenCompraService.actualizarEstado(data);

        if (response.status === 200) {
            var empty = this.fetchEmptyFormValues();
            this.setState({ visible: false, formValues: empty });
            form.setFieldsValue(empty);
            form.resetFields();

            message.success('Registrado rechazado correctamente.');

            this._handlePagination(this.state.filter);
            return;
        }

        if (response.status === 400) {
            dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
            return;
        }

        dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');

    }

    handleAprobar = async (values) => {
        dialog.confirm(`¿Desea aprobar la Orden de Compra ${values.serie}-${values.documento}?`, async () => {
            debugger
            var data = {
                idOrdenCompra: values.id,
                codOrdenCompraEstado: 'AP'
            };
            var response = await ordenCompraService.actualizarEstado(data);

            if (response.status === 200) {
                var empty = this.fetchEmptyFormValues();
                this.setState({ visible: false, formValues: empty });
                //form.setFieldsValue(empty);
                //form.resetFields();

                message.success('Registrado aprobado correctamente.');

                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    }

    fetchEmptyFormValues = () => {
        var d = new Date();
        var _year = d.getFullYear();
        return {
            id: 0,
            idCliente: 0, //..........................................................OK
            idEstablecimientoCliente: 0, //..........................................................OK
            idAlmacen: 0, //..........................................................OK
            idMoneda: SOLES, //..........................................................OK
            idListaPrecio: 0, //..........................................................OK
            idEstablecimiento: 0, //..........................................................OK
            idProyecto: 0,
            serie: _year, //............................................... OK
            documento: "", //............................................... OK
            fechaStr: global.fetchCurrentDateStr(), //......................................... OK
            fechaVencimientoStr: global.fetchCurrentDateStr(), //......................................... OK
            diasVencimiento: 0, //..........................................................OK
            tipoCambio: 0, //..........................................................OK
            observacion: "", //..........................................................OK
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            /*********************/
            //sumaTotalDetalle: 0,
            //sumaImporteDescuento: 0,
            sumaSubTotal: 0,
            sumaIgv: 0,
            sumaTotal: 0,
            almacenLoading: false,
            clienteLoading: false,
            activeKey: "1",
            documentoCliente: "",
            monedas: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            clientes: [],
            direcciones: [],
            tiposComprobante: [],
            proyectos: [],
            idRequerimiento: 0
        }
    };

    fetchEditFormValues = (value) => {

        return {
            id: value.ordenCompra.id,
            idCliente: value.ordenCompra.idEntidadProveedor, //..........................................................OK
            idEstablecimientoCliente: value.ordenCompra.idEstablecimientoProveedor, //..........................................................OK
            idAlmacen: value.ordenCompra.idAlmacen, //..........................................................OK
            idMoneda: value.ordenCompra.idMoneda, //..........................................................OK
            idListaPrecio: 0, //..........................................................OK
            idEstablecimiento: value.ordenCompra.idEstablecimiento,
            idProyecto: value.ordenCompra.idProyecto,
            serie: value.ordenCompra.serie, //............................................... OK
            documento: value.ordenCompra.documento, //............................................... OK
            documentoCliente: value.ordenCompra.documentoProveedor,
            fechaStr: value.ordenCompra.fechaStr, //global.fetchCurrentDateStr(), //......................................... OK
            fechaVencimientoStr: value.ordenCompra.fechaVencimientoStr, //......................................... OK
            diasVencimiento: value.ordenCompra.diasVencimiento, //..........................................................OK
            tipoCambio: value.ordenCompra.tipoCambio, //..........................................................OK
            observacion: value.ordenCompra.observacion, //..........................................................OK
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            /*********************/
            //sumaTotalDetalle: 0,
            //sumaImporteDescuento: 0,
            sumaSubTotal: value.ordenCompra.subTotal,
            sumaIgv: value.ordenCompra.igv,
            sumaTotal: value.ordenCompra.total,
            //almacenLoading: false,
            clienteLoading: false,
            activeKey: "1",
            monedas: [],
            //tiposCambioDiario: [],
            listasPrecio: [],
            establecimientos: [],
            almacenes: [],
            //vendedores: [],
            clientes: [],
            direcciones: [],
            tiposComprobante: [],
            //detracciones: []
            proyectos: [],
            idRequerimiento: 0,
            nombreMoneda: value.ordenCompra.nombreMoneda,
            nombreProyecto: value.ordenCompra.nombreProyecto,
            nombreAlmacen: value.ordenCompra.nombreAlmacen,
            proveedor: value.ordenCompra.proveedor,
            direccionEstablecimiento: value.ordenCompra.direccionEstablecimiento,
            nombreEstablecimientoSucursal: value.ordenCompra.nombreEstablecimientoSucursal
        }
    }

    handleExportExcel = async () => {
        var response = await ordenCompraService.excel(this.state.filter);
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de OdenCompra.xlsx");
    }

    
    handleImprimir = async (item) => {
        
        var file = undefined;
        var response = await ordenCompraService.pdfA4({ id: item.id });
        file = window.URL.createObjectURL(response.data);

        this.setState({
            imprimirVisible: true,
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                file,
                idOrdenCompra: item.id
            }
        });
    };

    handleAnular = async (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            debugger
            var data = {
                idOrdenCompra: values.id,
                codOrdenCompraEstado: 'AN',
                observacionRechazado: ''
            };
            var response = await ordenCompraService.actualizarEstado(data);

            if (response.status === 200) {
                var empty = this.fetchEmptyFormValues();
                this.setState({ visible: false, formValues: empty });

                message.success('Registrado anulado correctamente.');

                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    }

    render() {

        return (
            <div>
                <Header
                    title="Bandeja de Orden de Compra"
                    onSearch={() => this._handlePagination(this.state.filter)}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    estado={this.estadosOrdenCompra}
                    entidades={this.state.proveedores}

                    onKeyUpSearch={this.handleKeyUpInput}
                    onKeyUpSearchSelect={this.handleKeyUpInputSelect}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingSource}
                    onExportExcel={this.handleExportExcel}
                    onChange={this._handleChangePagination}
                    onVer={this.handleVer}
                    onRechazar={this.handleRechazar}
                    onAprobar={this.handleAprobar}
                    onAnular={this.handleAnular}
                    onImprimir={this.handleImprimir}
                />
                <FormModalVer
                    visible={this.state.visibleVer}
                    formValues={this.state.formValues}
                    onChangeTab={this.handleChangeTab}
                    onClose={() => this.setState({ visibleVer: false })}
                />
                <IngresoObservacionModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleCompletarRechazo}
                />
                   <ImprimirModal
                    visible={this.state.imprimirVisible}
                    formValues={this.state.imprimirFormValues}
                    onChange={this.handleChangeImprimir}
                    onClose={() => this.setState({ imprimirVisible: false })}
                />
            </div>
        );
    }
}